import { render, staticRenderFns } from "./CategoriaPecaFornecedorForm.vue?vue&type=template&id=76d94c22"
import script from "./CategoriaPecaFornecedorForm.vue?vue&type=script&lang=js"
export * from "./CategoriaPecaFornecedorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports